import { render, staticRenderFns } from "./MerchantCredentials.vue?vue&type=template&id=0ffd0578&scoped=true&"
import script from "./MerchantCredentials.vue?vue&type=script&lang=ts&"
export * from "./MerchantCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd0578",
  null
  
)

export default component.exports